import { faPlus, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Row, Col, Button } from "@themesberg/react-bootstrap";
import { useContext, useEffect, useState } from "react";
import { PropertyContext } from "src/app/contexts/PropertyContext";
import AccordionComponent from "src/template/components/AccordionComponent";
import { HomeSectionsContext } from "../../contexts/HomeSectionsContext";
import HomeSectionsForm from "./HomeSectionsForm";

const HomeSections = () => {
	const {
		homeSectionsData,
		getAllHomeSectionsFromContext,
		createNewHomeSectionFromContext,
		updateHomeSectionFromContext,
		deleteHomeSectionFromContext,
	} = useContext(HomeSectionsContext);
	const [accordionComponenetData, setAccordionComponentData] = useState([{}]);
	const [newSectionForm, setNewSectionForm] = useState(false);
	const {
		categoryData,
		propertyDataLite,
		getAllCategoriesFromContext,
		getAllPropertyLiteFromContext,
	} = useContext(PropertyContext);

	const handleCreateNewSectionButtonClick = () => {
		setNewSectionForm(!newSectionForm);
	};

	useEffect(() => {
		if (homeSectionsData) {
			setAccordionComponentData(
				homeSectionsData.map((sectionData) => ({
					id: sectionData.id,
					eventKey: sectionData.id + sectionData.section,
					title: sectionData.section,
					description: (
						<HomeSectionsForm
							{...{
								singleHomeSection: sectionData,
								categoryData,
								propertyDataLite,
								updateHomeSectionFromContext,
								getAllHomeSectionsFromContext,
								deleteHomeSectionFromContext,
							}}
						/>
					),
				}))
			);
		}
	}, [homeSectionsData]);

	useEffect(() => {
		getAllHomeSectionsFromContext();
		getAllCategoriesFromContext();
		getAllPropertyLiteFromContext();
	}, []);

	return (
		<div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
			<Card border="light" className="shadow-sm w-100">
				<div className="mt-4 px-5">
					<center>
						<h5 className="mb-4">Home Sections</h5>
					</center>
				</div>
				<div className="px-5 pb-3">
					<Row>
						<Col>
							<Button
								variant={newSectionForm ? "danger" : "secondary"}
								className={newSectionForm ? "mt-4 text-light" : "mt-4 text-dark"}
								onClick={() => handleCreateNewSectionButtonClick()}
							>
								{newSectionForm ? (
									<>
										<FontAwesomeIcon icon={faWindowClose} className="me-2" />
										Cancel new input
									</>
								) : (
									<>
										<FontAwesomeIcon icon={faPlus} className="me-2" />
										Create New Section
									</>
								)}
							</Button>
						</Col>
					</Row>
					{newSectionForm && (
						<Row className="mt-4">
							<Col xs={12}>
								<HomeSectionsForm
									{...{
										categoryData,
										propertyDataLite,
										createNewHomeSectionFromContext,
										newSectionForm,
										setNewSectionForm,
										getAllHomeSectionsFromContext,
									}}
								/>
							</Col>
						</Row>
					)}
					<Row className="mt-4">
						<Col xs={12}>
							<AccordionComponent
								defaultKey="panel-1"
								data={accordionComponenetData}
							/>
						</Col>
					</Row>
				</div>
			</Card>
		</div>
	);
};

export default HomeSections;
